import WarningIcon from '@mui/icons-material/Warning';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {CustomContentProps, useSnackbar} from 'notistack';
import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import {SnackbarContent as CustomSnackbarContent} from './SnackbarContent';

export const NoLinkedInConnection = React.forwardRef<HTMLDivElement, CustomContentProps>(({id}, ref) => {
  const {closeSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  return (
    <CustomSnackbarContent
      ref={ref}
      color="error"
      icon={<WarningIcon />}
      title={t('notification.needlinkedintoken.title')}
      content={
        <>
          <Typography variant="body2">{t('notification.needlinkedintoken.content')}</Typography>
          {}
          <Button
            component={Link}
            variant="text"
            size="small"
            color="info"
            // @ts-ignore
            to="/auth/linkedin"
            sx={{pl: 0, mt: 2}}
          >
            {t('settings.linkedaccount.updatewithlinkedinbtn')}
          </Button>
        </>
      }
      onClose={handleDismiss}
      bgWhite
      titleColor="error"
      dividerColor={false}
    />
  );
});
